import { render, staticRenderFns } from "./SharesEditTable.vue?vue&type=template&id=f77cf082&scoped=true&"
import script from "./SharesEditTable.vue?vue&type=script&lang=js&"
export * from "./SharesEditTable.vue?vue&type=script&lang=js&"
import style0 from "./SharesEditTable.vue?vue&type=style&index=0&id=f77cf082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77cf082",
  null
  
)

export default component.exports